import React, { useState, useEffect } from "react";
import {
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter,
  ModalCloseButton, FormControl, FormLabel, Select, Textarea, Button, VStack, Text, useToast,
} from "@chakra-ui/react";
import { registrarCrmAtividade } from "../../services/api";
import { RESULTADOS } from "./crmUtils";

const ACCENT = "#F68633";

export default function RegistrarAtividadeModal({ isOpen, onClose, clienteId, clienteNome, tarefa, onSaved }) {
  const [tipo, setTipo] = useState("ligacao");
  const [resultado, setResultado] = useState("");
  const [resumo, setResumo] = useState("");
  const [salvando, setSalvando] = useState(false);
  const toast = useToast();

  useEffect(() => {
    if (isOpen) { setTipo("ligacao"); setResultado(""); setResumo(""); }
  }, [isOpen]);

  const salvar = async () => {
    setSalvando(true);
    const r = await registrarCrmAtividade(clienteId, {
      tipo,
      resultado: resultado || null,
      resumo: resumo || null,
      tarefa_id: tarefa?.id || null,
    });
    setSalvando(false);
    if (r?.data) {
      toast({ status: "success", title: tarefa ? "Atividade registrada e tarefa concluída" : "Atividade registrada" });
      onSaved?.();
      onClose();
    } else {
      toast({ status: "error", title: "Erro", description: r?.error || "Não foi possível registrar." });
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md" isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader fontSize="md">Registrar atividade{clienteNome ? ` — ${clienteNome}` : ""}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack align="stretch" spacing={3}>
            {tarefa && (
              <Text fontSize="xs" color="gray.500">
                Ao salvar, a tarefa <b>{tarefa.motivo}</b> será concluída.
              </Text>
            )}
            <FormControl>
              <FormLabel fontSize="sm">Tipo de contato</FormLabel>
              <Select size="sm" value={tipo} onChange={(e) => setTipo(e.target.value)}>
                <option value="ligacao">Ligação</option>
                <option value="whatsapp">WhatsApp</option>
              </Select>
            </FormControl>
            <FormControl>
              <FormLabel fontSize="sm">Resultado</FormLabel>
              <Select size="sm" placeholder="Selecione..." value={resultado} onChange={(e) => setResultado(e.target.value)}>
                {RESULTADOS.map((r) => <option key={r.value} value={r.value}>{r.label}</option>)}
              </Select>
            </FormControl>
            <FormControl>
              <FormLabel fontSize="sm">Resumo</FormLabel>
              <Textarea size="sm" rows={4} placeholder="O que foi conversado..." value={resumo} onChange={(e) => setResumo(e.target.value)} />
            </FormControl>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button size="sm" variant="ghost" mr={2} onClick={onClose}>Cancelar</Button>
          <Button size="sm" bg={ACCENT} color="white" _hover={{ bg: "#d4702a" }} onClick={salvar} isLoading={salvando}>
            Salvar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
